import { cn } from "common/utils/utils";
import { FC, PropsWithChildren } from "react";

type BannerVariant = "info" | "success" | "warning" | "error";

type BannerProps = {
  variant?: BannerVariant;
  visible?: boolean;
  onClose?: () => void;
  className?: string;
};

const KroBanner: FC<PropsWithChildren<BannerProps>> = ({
  variant = "info",
  visible = true,
  onClose,
  children,
  className,
}) => {
  const getBackgroundColor = () => {
    switch (variant) {
      case "info":
        return "bg-[#EBF1FF]"; // Using exact hex color
      case "success":
        return "bg-green-50";
      case "warning":
        return "bg-amber-50";
      case "error":
        return "bg-red-50";
      default:
        return "bg-[#EBF1FF]";
    }
  };

  if (!visible) return null;

  return (
    <div
      className={cn(
        "flex w-full max-w-full flex-row items-center p-4",
        getBackgroundColor(),
        className,
      )}
    >
      <div className="flex flex-grow items-center justify-center">
        {children}
      </div>

      {onClose && (
        <div className="flex flex-shrink-0 items-center justify-center">
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onClose}
          >
            <img
              src="/assets/icons/close.svg"
              className="h-[20px] w-[20px]"
              alt="close"
            />
          </button>
        </div>
      )}
    </div>
  );
};

export default KroBanner;
